<template>
  <div class="container mt-0 mb-4">
    <div class="card shadow-sm p-4 bg-light">
      <h3 class="text-center mb-4">Limpieza de Habitaciones</h3>

      <div v-if="habitaciones.length === 0" class="text-center text-muted">
        No hay habitaciones pendientes de limpieza.
      </div>

      <!-- Tabla resumen de habitaciones pendientes -->
      <div v-if="habitaciones.length > 0" class="mb-4">
        <h5 class="mb-3">Habitaciones Pendientes de Limpieza</h5>
        <div class="table-responsive">
          <table class="table table-bordered table-hover align-middle">
            <thead class="table-light">
              <tr>
                <th class="text-center">Habitación</th>
                <th class="text-center">Personas</th>
                <th class="text-center">Prioridad</th>
                <th class="text-center">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="hab in habitaciones" :key="hab.IdReservaHabitacion">
                <td class="text-center fw-bold">{{ hab.habitacion?.Numero }}</td>
                <td class="text-center">{{ hab.CantidadPersonasAlojadas }}</td>
                <td class="text-center">
                  <span v-if="hab.LimpiezaUrgente == 1" class="badge bg-danger">Urgente</span>
                  <span v-else class="badge bg-secondary">Normal</span>
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-sm btn-primary"
                    @click="scrollToHabitacion(hab.IdReservaHabitacion)">
                    <i class="bx bx-edit-alt"></i> Realizar Limpieza
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Buscador -->
      <div v-if="habitaciones.length > 0" class="mb-4">
        <label class="form-label">Buscar por número de habitación:</label>
        <input type="text" v-model="busqueda" class="form-control" placeholder="Ej: 31, 32" />
      </div>

      <div
        v-for="hab in habitacionesFiltradas"
        :key="hab.IdReservaHabitacion"
        :data-habitacion="hab.IdReservaHabitacion"
        :class="['card mb-3 shadow-sm', hab.LimpiezaUrgente == 1 ? 'border-2 border-danger' : '']"
      >
        <div class="card-body">
          <h5 class="card-title">Habitación {{ hab.habitacion?.Numero }}</h5>
          <span v-if="hab.LimpiezaUrgente == 1" class="badge bg-danger ms-2">Limpieza Urgente</span>
          <p><strong>Personas alojadas:</strong> {{ hab.CantidadPersonasAlojadas }}</p>

          <!-- Productos sin usar -->
          <div class="row mb-3">
            <div class="col-md-3">
              <label class="form-label">Toallas Disponibles</label>
              <select v-model.number="formulario[hab.IdReservaHabitacion].Toalla" class="form-select">
                <option v-for="n in 11" :key="n" :value="n - 1">{{ n - 1 }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Jabones Disponibles</label>
              <select v-model.number="formulario[hab.IdReservaHabitacion].Jabon" class="form-select">
                <option v-for="n in 11" :key="n" :value="n - 1">{{ n - 1 }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Shampoos Disponibles</label>
              <select v-model.number="formulario[hab.IdReservaHabitacion].Shampoo" class="form-select">
                <option v-for="n in 11" :key="n" :value="n - 1">{{ n - 1 }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Botellas de Agua Disponibles</label>
              <select v-model.number="formulario[hab.IdReservaHabitacion]['Botella de Agua']" class="form-select">
                <option v-for="n in 11" :key="n" :value="n - 1">{{ n - 1 }}</option>
              </select>
            </div>
          </div>

          <!-- Observación limpieza -->
          <div class="mb-3">
            <label class="form-label">Observación (opcional)</label>
            <textarea v-model="formulario[hab.IdReservaHabitacion].ObservacionLimpieza" class="form-control" rows="2" placeholder="Escribe un comentario si es necesario"></textarea>
          </div>

         <!-- Confirmar limpieza -->
<div class="form-check mb-2">
  <input class="form-check-input" type="checkbox"
         :id="'confirmar-' + hab.IdReservaHabitacion"
         v-model="formulario[hab.IdReservaHabitacion].confirmado"
         @change="formulario[hab.IdReservaHabitacion].rechazado = false">
  <label class="form-check-label" :for="'confirmar-' + hab.IdReservaHabitacion">
    Confirmar limpieza completada
  </label>
</div>

<!-- Rechazar limpieza -->
<div class="form-check mb-3">
  <input class="form-check-input" type="checkbox"
         :id="'rechazar-' + hab.IdReservaHabitacion"
         v-model="formulario[hab.IdReservaHabitacion].rechazado"
         @change="formulario[hab.IdReservaHabitacion].confirmado = false">
  <label class="form-check-label text-danger" :for="'rechazar-' + hab.IdReservaHabitacion">
    Cliente no deseó limpieza
  </label>
</div>


         <button class="btn btn-success w-100"
        @click="enviarLimpieza(hab.IdReservaHabitacion)"
        :disabled="procesando[hab.IdReservaHabitacion] || (!formulario[hab.IdReservaHabitacion].confirmado && !formulario[hab.IdReservaHabitacion].rechazado)">
  <span v-if="procesando[hab.IdReservaHabitacion]">
    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    Procesando...
  </span>
  <span v-else>Finalizar Limpieza</span>
</button>

        </div>
      </div>
    </div>

    <!-- Modal de respuesta -->
    <div class="modal fade show d-block" v-if="modalVisible" tabindex="-1" style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white shadow">
          <div class="modal-header">
            <h5 class="modal-title">Resultado de la Limpieza</h5>
            <button type="button" class="btn-close" @click="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <h6 class="fw-bold">Reposición a la Habitación:</h6>
            <ul>
              <li v-for="item in productosRepuestos" :key="'r-' + item">{{ item }}</li>
            </ul>

            <h6 class="fw-bold mt-3">Devoluciones al Inventario:</h6>
            <ul>
              <li v-for="item in productosDevueltos" :key="'d-' + item">{{ item }}</li>
            </ul>

            <p class="mt-3">{{ mensaje }}</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="cerrarModal">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'

export default {
  name: 'LimpiezaHabitaciones',
  data() {
    return {
      habitaciones: [],
      formulario: {},
      procesando: {},
      modalVisible: false,
      mensaje: '',
      productosRepuestos: [],
      productosDevueltos: [],
      intervalo: null,
      busqueda: ''
    }
  },
  computed: {
  habitacionesFiltradas() {
    if (!this.busqueda) return this.habitaciones
    const filtro = this.busqueda.toString().toLowerCase()
    return this.habitaciones.filter(hab =>
      hab.habitacion?.Numero?.toString().toLowerCase().includes(filtro)
    )
  }
},
  async mounted() {
    await this.cargarHabitaciones()
    this.intervalo = setInterval(this.cargarHabitaciones, 30000)
  },
  beforeUnmount() {
    clearInterval(this.intervalo)
  },
  methods: {
    async cargarHabitaciones() {
      try {
        const res = await axios.get(`${API_URL}/habitacionesPendientes-limpieza`)
        this.habitaciones = res.data.pendientes || []

        this.habitaciones.forEach(hab => {
          if (!this.formulario[hab.IdReservaHabitacion]) {
            this.formulario[hab.IdReservaHabitacion] = {
              Toalla: 1,
              Jabon: 1,
              Shampoo: 1,
              "Botella de Agua": 1,
              ObservacionLimpieza: '',
              confirmado: false,
               rechazado: false
            }
          }
        })
      } catch (error) {
        console.error('Error cargando habitaciones:', error)
      }
    },
   async enviarLimpieza(idReservaHabitacion) {
  // Evita doble envío / doble descuento de inventario si el botón se presiona más de una vez
  if (this.procesando[idReservaHabitacion]) return
  this.procesando[idReservaHabitacion] = true

  const datos = this.formulario[idReservaHabitacion]

  try {
    if (datos.rechazado) {
      // Si rechazó limpieza, llamamos al endpoint especial
      const res = await axios.put(`${API_URL}/limpieza-rechazada/${idReservaHabitacion}`)
      this.mensaje = res.data.message || 'Limpieza marcada como rechazada.'
    } else {
      // Limpieza normal
      const res = await axios.put(`${API_URL}/reservas-habitacion/limpieza/${idReservaHabitacion}`, datos)
      this.mensaje = res.data.message || 'Limpieza registrada.'
      this.productosRepuestos = res.data.productos_repuestos || []
      this.productosDevueltos = res.data.productos_devueltos || []
    }

    this.modalVisible = true
    delete this.formulario[idReservaHabitacion]
    this.habitaciones = this.habitaciones.filter(h => h.IdReservaHabitacion !== idReservaHabitacion)
  } catch (error) {
    this.mensaje = error.response?.data?.message || 'Error al registrar limpieza.'
    this.productosRepuestos = []
    this.productosDevueltos = []
    this.modalVisible = true
  } finally {
    delete this.procesando[idReservaHabitacion]
  }
}
,
    cerrarModal() {
      this.modalVisible = false
      this.productosRepuestos = []
      this.productosDevueltos = []
      this.mensaje = ''
    },
    scrollToHabitacion(idReservaHabitacion) {
      // Buscar el elemento de la habitación y hacer scroll
      this.$nextTick(() => {
        const elemento = document.querySelector(`[data-habitacion="${idReservaHabitacion}"]`)
        if (elemento) {
          elemento.scrollIntoView({ behavior: 'smooth', block: 'center' })
          // Resaltar brevemente el elemento
          elemento.classList.add('bg-warning', 'bg-opacity-25')
          setTimeout(() => {
            elemento.classList.remove('bg-warning', 'bg-opacity-25')
          }, 2000)
        }
      })
    }
  }

}

</script>

<style scoped>
label {
  font-weight: 500;
}
</style>
